// extracted by mini-css-extract-plugin
export var infoItem = "_rc-2";
export var title = "_rc-0";
export var value = "_rc-1";